import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, X } from "lucide-react";
import { Separator } from '../ui/separator';

interface DialogProps {
    isOpen: boolean;
    onClose?: () => void;
    onProceed?: () => void;
    bookingId?: string;
    title: any;
    description?: any;
    cancelBtnTitle?: string;
    proceedBtnTitle?: string;
    footer?: any;
    showDefaultFooter?:boolean
    headerIcon?:any
    showHeaderIcon?:boolean
    showCloseIcon?:boolean
    mainclassName?:string
    showfooter?:boolean
}

const Dialog = ({
    isOpen,
    onClose,
    onProceed,
    bookingId,
    title,
    description,
    footer,
    cancelBtnTitle,
    proceedBtnTitle,
    showDefaultFooter=true,
    headerIcon=null,
    showHeaderIcon=true,
    showCloseIcon=true,
    mainclassName="",
    showfooter=true

}: DialogProps) => {
    return (
        <AlertDialog open={isOpen} onOpenChange={onClose}>
            <AlertDialogContent className={`    px-0
                    max-h-[90vh]
                    flex
                    flex-col ${mainclassName?mainclassName:"w-full rounded-sm sm:max-w-lg"}`}>
                <AlertDialogHeader className='px-3'>
                    <div className="flex items-center gap-3 relative mb-0">
                        {headerIcon?
                            <div className="p-2 bg-green-200 rounded-full border-2 border-green-300">
                                {headerIcon}
                            </div>:
                           showHeaderIcon &&<div className="p-2 bg-orange-100 rounded-full">
                                <AlertTriangle className="w-5 h-5 text-orange-600" />
                            </div>
                        }
                       
                        <AlertDialogTitle className="text-lg font-semibold text-flup-brand">
                            {typeof title === "function"?title():title || "Alert"}
                        </AlertDialogTitle>
                       {showCloseIcon && <X className="w-5 h-5 absolute right-2 top 2" onClick={onClose} />}
                    </div>

                </AlertDialogHeader>
                <Separator />

                <AlertDialogDescription className="text-left space-y-3 pt-2 px-4 overflow-y-auto">

                    {/* Scrollable Body */}
                    {/* <div className="px-4 py-3 overflow-y-auto flex-1"> */}
                    {description}
                    {/* </div> */}
                </AlertDialogDescription>

                
               {showfooter &&
                (<AlertDialogFooter className="gap-2 px-4 ">
                    {footer ? footer :
                        <>

                           {showDefaultFooter && 
                           <>

                           <AlertDialogCancel
                                onClick={onClose}
                                className="flex-1"
                            >
                                {cancelBtnTitle || "Cancel"}
                            </AlertDialogCancel>
                            <AlertDialogAction
                                onClick={onProceed}
                                className="flex-1 bg-red-600 hover:bg-red-700"
                            >
                                {proceedBtnTitle || "Proceed with Cancellation"}
                            </AlertDialogAction>
                            </>}

                        </>

                    }
               

                </AlertDialogFooter>)
                }   
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default Dialog;
